export default __webpack_public_path__ + "static/media/Group1029.0a1464d7.svg";